import React from 'react';

import ApproveForm from '../../Framework/Components/Form/ApproveForm';
import BlockStyledEditor from '../../Framework/Components/Form/BlockStyledEditor';
import BrandInput from '../../Framework/Components/Form/BrandInput';
import IngredientInput from '../../Framework/Components/Form/IngredientInput';
import VariantListInput from '../../Framework/Components/Form/VariantListInput';
import TextInput from '../../Framework/Components/Form/TextInput';
import Image from '../../Framework/Components/Image/Image';
import Grid, { GridLeft, GridRight } from '../../Framework/Layouts/Grid';

import style from '../../../scss/components/form.module.scss';
import EanCodesInput from '../../Framework/Components/Form/EanCodesInput';
import CategoryDropdown from '../../Framework/Components/Form/Dropdown/CategoryDropdown';
import CategoryHierarchyGroup from '../Categories/CategoryHierarchyGroup';
import ConcernGroup from '../Categories/ConcernGroup';

const ProductChangeRequestForm = (props) => {
    return (
        <ApproveForm creates="products" {...props}>
            <Grid>
                <GridLeft>
                    <BrandInput name="brand" />
                    <TextInput className={style.changedInput} name="name" />
                    <TextInput name="canonical_name" />
                    <VariantListInput name="variants" />
                    <BlockStyledEditor name="description" fullFeatureSet />
                    <Image name="images" limit={10} isDetachable />
                </GridLeft>
                <GridRight>
                    <EanCodesInput resource="products" name="eans" />
                    <CategoryHierarchyGroup />
                    <CategoryDropdown
                        name="secondary_categories"
                        requestName="secondaryCategories"
                        type="product"
                        isMultiple
                        requiredField="primary_category"
                        excludedFields={[
                            'primary_category',
                            'sub_category',
                            'sub_sub_category',
                        ]}
                    />
                    <CategoryDropdown name="skin_types" type="skintype" />
                    <ConcernGroup />
                    <IngredientInput
                        className="tidy-tokens"
                        name="ingredients"
                        isOrderable
                        isReversable
                        allowNew
                    />
                </GridRight>
            </Grid>
        </ApproveForm>
    );
};

export default ProductChangeRequestForm;
